import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-activity-info',
  templateUrl: './activity-info.component.html',
  styleUrls: ['./activity-info.component.scss']
})
export class ActivityInfoComponent implements OnInit {
  @Input() activity?: any ;

  constructor() { }

  ngOnInit(): void {
  }

}
